(function() {
    'use strict';

    angular
        .module('platformApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
